import { DynamicObjectInterface } from '../../../sdk/type';
import { FAIcon, Tag, TagStyle, Theme } from '../../../ui/components';
import { GetColumnsType } from '../../../ui/components/TableContainer/types/propsTypes';
import { dateTimeToCustomFormat } from '../../../ui/utils';

type IProductBO = {
  [key: string]: DynamicObjectInterface;
};

const getParticipantListConfig: GetColumnsType = (
  styles: DynamicObjectInterface,
  translation: DynamicObjectInterface,
  cb: DynamicObjectInterface,
) => [
  {
    key: 'name',
    text: translation('admin.teamEdit.participantName'),
    width: 4,
    sortable: false,
    render: (object: IProductBO) => <span>{object.name === null ? '-' : object.name}</span>,
  },
  {
    key: 'aboId',
    text: translation('admin.teamEdit.participantAboId'),
    width: 4,
    sortable: false,
    render: (object: IProductBO) => <span>{object.loginId === null ? '-' : object.loginId}</span>,
  },
  {
    key: 'weightInDate',
    text: translation('admin.teamEdit.weighIn'),
    sortable: false,
    width: 4,
    render: (object: IProductBO) => (
      <span>
        {object.weightIn.weightInDate === null
          ? '-'
          : dateTimeToCustomFormat(object.weightIn.weightInDate, 'DD/MM/yyyy')}
      </span>
    ),
  },
  {
    key: 'weightOutDate',
    text: translation('admin.teamEdit.weighOut'),
    sortable: false,
    width: 4,
    render: (object: IProductBO) => (
      <span>
        {object.weightOut.weightOutDate === null
          ? '-'
          : dateTimeToCustomFormat(object.weightOut.weightOutDate, 'DD/MM/yyyy')}
      </span>
    ),
  },
  // {
  //   key: 'acknowledgeDateTimeOut',
  //   text: translation('admin.teamEdit.acknowledgedDateOut'),
  //   sortable: true,
  //   width: 4,
  //   render: (object: IProductBO) => (
  //     <span>
  //       {object.weightOut.acknowledgeDateTime === null
  //         ? '-'
  //         : dateTimeToCustomFormat(object.weightOut.acknowledgeDateTime, 'DD/MM/yyyy')}
  //     </span>
  //   ),
  // },
  {
    key: 'orderStatus',
    text: translation('admin.teamEdit.purchase'),
    sortable: false,
    width: 4,
    render: (object: IProductBO) => (
      <span>
        <Tag
          theme={object.orderStatus === 'YES' ? Theme.SUCCESS : Theme.WARNING}
          style={TagStyle.OUTLINE}
          text={object.orderStatus}
        />
      </span>
    ),
  },
  {
    key: 'isIndividualAchieved',
    text: translation('admin.teamEdit.achieved'),
    sortable: false,
    width: 4,
    render: (object: IProductBO) => (
      <span>
        <Tag
          theme={
            object.isIndividualAchieved === 'YES'
              ? Theme.SUCCESS
              : object.isIndividualAchieved === 'NO'
                ? Theme.WARNING
                : Theme.BLUE
          }
          style={TagStyle.OUTLINE}
          text={object.isIndividualAchieved}
        />
      </span>
    ),
  },
  {
    key: 'isNewABO',
    text: translation('admin.participant.isNewAbo'),
    sortable: false,
    width: 4,
    render: (object: IProductBO) => (
      <span>
        <Tag
          theme={object.isNewABO === 1 ? Theme.SUCCESS : object.isNewABO === 0 ? Theme.WARNING : Theme.BLUE}
          style={TagStyle.OUTLINE}
          text={object.isNewABO === 1 ? 'YES' : 'NO'}
        />
      </span>
    ),
  },
  {
    key: 'status',
    text: translation('admin.teamEdit.status'),
    sortable: false,
    width: 2,
    render: (object: IProductBO) => (
      <span>
        <Tag
          theme={object.status === 'ACTIVE' ? Theme.SUCCESS : Theme.WARNING}
          style={TagStyle.OUTLINE}
          text={object.status}
        />
      </span>
    ),
  },
  // {
  //   key: 'orderNumber',
  //   text: translation('admin.teamEdit.orderNumber'),
  //   width: 4,
  //   sortable: true,
  //   render: (object: IProductBO) => (
  //     <span>{object.purchaseData.orderNumber === null ? '-' : object.purchaseData.orderNumber}</span>
  //   ),
  // },

  {
    key: 'actions',
    width: 1,
    text: translation('admin.teamEdit.actions'),
    render: (object: IProductBO) => (
      <>
        <FAIcon
          iconName={'edit'}
          onClick={e => {
            cb?.onEdit(object);
            e.stopPropagation();
          }}
          theme={Theme.PURPLE}
        />
        {' | '}
        <FAIcon
          iconName={'trash-can'}
          onClick={e => {
            cb?.onDelete(object);
            e.stopPropagation();
          }}
          theme={Theme.PURPLE}
          title={'Delete'}
        />
        {/*{' | '}
         <FAIcon
          iconName={'check-circle'}
          iconStyle={IconStyle.REGULAR}
          onClick={e => {
            cb?.onClick(object);
            e.stopPropagation();
          }}
          //theme={object.acknowledgement ? Theme.GREEN : Theme.PURPLE}
          theme={Theme.PURPLE}
        />
        {' | '}
        <FAIcon
          iconName={'calendar'}
          onClick={e => {
            cb?.onCalendar(object);
            e.stopPropagation();
          }}
          theme={Theme.PURPLE}
        /> */}
      </>
    ),
  },
];

export default getParticipantListConfig;
